export default {"src":"/_next/static/media/globe-icon.4e22787c.svg","height":106,"width":104,"blurWidth":0,"blurHeight":0};